module.exports = __webpack_public_path__ + "img/arrow-right.423e5426.svg";